import TareasCV from "./controladorVista/tareasCV"

export const Tareas = () => {
    return (
        <TareasCV />
    );
}